import { useMemo } from 'react';

import { useLaunchDarklyFlag } from '@/hooks/flags/useLaunchDarklyFlag';

import type { UseShouldShowReferralBannerParams } from './types';

/**
 * Returns true when the client referral banner should appear.
 *
 * Gates (must all pass):
 * 1. LD flag `client-referrals` is on
 * 2. Shop has at least one active referral program (deletedAt === null)
 * 3. Customer is signed in
 */
export const useShouldShowReferralBanner = ({
  shop,
  customerId,
}: UseShouldShowReferralBannerParams): boolean => {
  const flagEnabled = useLaunchDarklyFlag('client-referrals', false);

  return useMemo(() => {
    if (!flagEnabled || !customerId) {
      return false;
    }

    return (
      shop?.clientReferrals?.some((program) => program.deletedAt === null) ??
      false
    );
  }, [flagEnabled, customerId, shop]);
};
